import React from 'react'
import { StyleSheet, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { DS } from '../../design-system'
import { StatusBar, StatusBarStyle } from 'expo-status-bar'
import { defaultBreakPoints, isWeb } from '@/components/WebWrapper'

interface NotificationScreenLayoutProps extends React.PropsWithChildren {
  firstButtonLabel?: string
  secondButtonLabel?: string
  onFirstButtonPress?: () => void
  onSecondButtonPress?: () => void
}

export const NotificationScreenLayout = ({
  children,
  firstButtonLabel,
  secondButtonLabel,
  onFirstButtonPress,
  onSecondButtonPress
}: NotificationScreenLayoutProps) => {
  return (
    <SafeAreaView style={styles.container}>
      <StatusBar animated={true} style={'dark' as StatusBarStyle} hidden={false} />
      <View style={styles.webContainer}>
        <DS.Frame style={styles.mainContainer}>
          <DS.Frame style={styles.centeredFrame}>{children}</DS.Frame>
          <DS.Frame style={styles.bottomFrame}>
            <DS.Button type="On Light" variant="Large/Primary" onPress={onFirstButtonPress}>
              {firstButtonLabel}
            </DS.Button>
            <DS.Button type="On Dark" variant="Large/Secondary" onPress={onSecondButtonPress}>
              {secondButtonLabel}
            </DS.Button>
          </DS.Frame>
        </DS.Frame>
      </View>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  webContainer: {
    width: '100%',
    maxWidth: isWeb ? defaultBreakPoints.sm : undefined,
    marginHorizontal: isWeb ? 'auto' : undefined,
    flex: 1
  },
  container: {
    flex: 1,
    backgroundColor: DS.palette['Brand/Cream']
  },
  mainContainer: {
    paddingHorizontal: 24,
    flex: 1
  },
  centeredFrame: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  bottomFrame: {
    gap: 8,
    paddingBottom: 20,
    justifyContent: 'flex-end'
  }
})
